//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Table from '../../../components/Table/Table.vue'
import TableCellObject from '../../../components/Table/TableCellObject.vue'
import { convertTime } from '../../../components/helpers.js'
import { businessProcessEventsHistory } from '../../../components/BusinessProcess/BusinessProcessEvents/businessProcessEventsHistory.js'

export default {
  components: {
    Table,
    TableCellObject
  },
  mixins: [businessProcessEventsHistory],
  props: {
    departureReports: {
      type: Array,
      default: () => {
        return []
      }
    },
    vehicleProvision: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data: function () {
    return {
      pagination: {
        rowsPerPage: 25,
        page: 1
      },
      columns: [
        {
          name: 'departureNumber',
          label: 'Порядковый номер точки маршрута (выезда)',
          align: 'left',
          field: 'departureNumber',
          sortable: true
        },
        {
          name: 'arrivalTime',
          label: 'Подача ТС',
          align: 'left',
          field: 'arrivalTime',
          format: convertTime,
          sortable: true
        },
        {
          name: 'brigade',
          label: 'Бригада',
          align: 'left',
          field: 'brigade',
          format: brigade => brigade ? brigade.name : '',
          sortable: true
        },
        {
          name: 'serviceObject',
          label: 'Объект обслуживания',
          align: 'left',
          field: 'serviceObject',
          sortable: true,
          columnFormat: 'object',
          columnObjectType: 'serviceObject'
        },
        {
          name: 'project',
          label: 'Проект',
          align: 'center',
          defaultWidth: 200,
          field: 'project',
          sortable: true,
          columnFormat: 'object',
          columnObjectType: 'project'
        },
        {
          name: 'address',
          label: 'Адрес',
          align: 'left',
          field: 'address',
          sortable: true
        },
        {
          name: 'notActual',
          label: 'В отчёте отмечено, что фактически ТС отсутствовало на объекте',
          align: 'left',
          field: 'notActual',
          format: value => value ? 'Да' : 'Нет',
          sortable: true
        },
        {
          name: 'comment',
          label: 'Комментарий к фактическому отсутствию ТС на объекте',
          align: 'left',
          field: 'comment',
          sortable: true
        }
      ]
    }
  },
  computed: {
    record: function () {
      return this.vehicleProvision
    }
  },
  methods: {
    getTrClass: function (row) {
      if (row.notActual) {
        return 'd-tr--grey'
      }
    },
    onOpenEvent: function (eventId) {
      const event = this.vehicleProvision.bp.events.find(event => event.id === eventId)
      if (event) {
        this.onOpen(event)
      }
    }
  }
}

